export type MargauxPromptStatus = "DRAFT" | "PUBLISHED" | "ARCHIVED";

export interface MargauxPromptVersion {
  id: string;
  body: string;
  status: MargauxPromptStatus;
  createdAt: string;
  createdBy: string | null;
  publishedAt: string | null;
}

export type MargauxPreviewMethod =
  | "generateIntro"
  | "generateHookLine"
  | "generateMidWeekPrompt"
  | "generateOpener";

export interface PreviewBookInput {
  title: string;
  author: string;
  description?: string | null;
  themes?: string[];
  authorBackground?: string | null;
  notableReviews?: string | null;
  discussionAngles?: string[];
}

export interface PreviewInput {
  body: string;
  method: MargauxPreviewMethod;
  book: PreviewBookInput;
}

export interface PreviewResult {
  output: string | null;
}

export const PREVIEW_METHOD_LABELS: Record<MargauxPreviewMethod, string> = {
  generateIntro: "Intro + ice-breaker",
  generateHookLine: "Hook line",
  generateMidWeekPrompt: "Mid-week prompt",
  generateOpener: "Weekly opener",
};

export const SAMPLE_BOOKS: Array<{ id: string; book: PreviewBookInput }> = [
  {
    id: "mrs-dalloway",
    book: {
      title: "Mrs Dalloway",
      author: "Virginia Woolf",
      description:
        "A day in the life of Clarissa Dalloway, weaving past memories and present moments through stream-of-consciousness prose.",
      themes: ["consciousness", "time", "post-war Britain"],
      discussionAngles: [
        "How does Woolf's prose change the way you experience time?",
        "What does Septimus reveal about Clarissa?",
      ],
    },
  },
  {
    id: "1984",
    book: {
      title: "1984",
      author: "George Orwell",
      description:
        "A dystopian novel about a totalitarian regime that watches every citizen.",
      themes: ["surveillance", "totalitarianism", "language control"],
      discussionAngles: [
        "Is Big Brother a metaphor for modern tech companies?",
        "How does Newspeak relate to modern language trends?",
      ],
    },
  },
  {
    id: "beloved",
    book: {
      title: "Beloved",
      author: "Toni Morrison",
      description:
        "A formerly enslaved woman is haunted by the ghost of her dead daughter.",
      themes: ["memory", "slavery", "motherhood"],
      discussionAngles: [
        "What is Morrison saying about memory and trauma?",
        "Is Beloved a ghost, a metaphor, or both?",
      ],
    },
  },
];
